import React, { lazy } from 'react';
import IconNet from '@/assets/images/menu/icon-net.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const trafficRoutes = (): IRouteConfig[] => [
  {
    path: '/traffic',
    name: '流量',
    icon: <MenuIcon icon={IconNet} fontSize={16} />,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.VisionOS,
      CapitalPlatform.Mac,
      CapitalPlatform.AppleTV,
    ],
    sort: 90,
    authName: AuthNodes.Traffic,
    disabledByFree: true,
    routes: [
      {
        path: '/traffic/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/traffic/analytics')),
      },
      {
        path: '/traffic/issues/detail',
        name: '异常详情',
        component: lazy(() => import('@/presentation/pages/traffic/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/traffic/issues/case',
        name: '异常个例详情',
        component: lazy(() => import('@/presentation/pages/traffic/issues/case')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/traffic/issues',
        name: '异常分析',
        component: lazy(() => import('@/presentation/pages/traffic/issues/list')),
      },
    ],
  },
];

export default trafficRoutes;
